import * as UseLive from '@webqit/use-live';
import init from './init.js';

init.call( window, UseLive );
